import { EventBase } from "@vp/models";

export interface AvailabilityChangedEventArgs {
  /** The user whose availability or presence changed. */
  userId: string;
}

/**
 * Pushed when a user's availability changes. It names the user only; readers
 * refetch what they show, so the push never widens who can see what.
 */
export class AvailabilityChangedEvent extends EventBase<AvailabilityChangedEventArgs> {
  constructor(eventArgs: AvailabilityChangedEventArgs) {
    super();
    this.args = eventArgs;
  }
}
